import {Model, Collection} from 'vue-mc'

export default class WidgetList extends Collection {
  async fetch(params) {
    let request = await this.createRequest({
      method: 'GET',
      url: `/api/v2/widgets?scope=${params.scope}&lang=${params.lang}`
    }).send()

    if(request.response.data.widgets) {
      return request.response.data.widgets
    }
    return []
  }
}
